export default function TimelineSection() {
  const timeline = [
    {
      day: 'Day 1',
      title: 'Initial Contact',
      description: 'Call us or submit your property information. We discuss your situation, tenant details, and answer all your questions.',
      icon: 'ri-phone-fill'
    },
    {
      day: 'Day 1-2',
      title: 'Property Review',
      description: 'We review property details, lease agreements, rent rolls, and tenant information. May schedule a brief inspection.',
      icon: 'ri-file-list-3-fill'
    },
    {
      day: 'Day 2-3',
      title: 'Cash Offer',
      description: 'Receive our competitive all-cash offer. No obligations. Take time to review and ask questions.',
      icon: 'ri-hand-coin-fill'
    },
    {
      day: 'Day 3-4',
      title: 'Offer Acceptance',
      description: 'If you accept, we immediately begin the closing process with our title company and schedule your closing date.',
      icon: 'ri-checkbox-circle-fill'
    },
    {
      day: 'Day 4-10',
      title: 'Title Work',
      description: 'Title company conducts title search, prepares documents, handles lease transfers, and tenant notifications.',
      icon: 'ri-shield-check-fill'
    },
    {
      day: 'Day 7-14',
      title: 'Closing Day',
      description: 'Sign final documents at title company. Receive your payment immediately. Tenants stay in place.',
      icon: 'ri-trophy-fill'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Typical Timeline: Contact to Closing
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Here's what to expect when you sell your tenant occupied property to T-Rex Real Estate. Most transactions close in 7-14 days.
          </p>
        </div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="hidden lg:block absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-teal-600 to-teal-400"></div>

          {/* Timeline Items */}
          <div className="space-y-12">
            {timeline.map((item, index) => (
              <div 
                key={index}
                className={`relative grid lg:grid-cols-2 gap-8 items-center ${
                  index % 2 === 0 ? '' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className={`${index % 2 === 0 ? 'lg:text-right lg:pr-12' : 'lg:col-start-2 lg:pl-12'}`}>
                  <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
                    <div className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-bold mb-4">
                      {item.day}
                    </div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">{item.title}</h3>
                    <p className="text-gray-700 leading-relaxed">{item.description}</p>
                  </div>
                </div>

                {/* Icon */}
                <div className={`hidden lg:flex absolute left-1/2 transform -translate-x-1/2 w-20 h-20 bg-teal-600 rounded-full items-center justify-center shadow-xl z-10 ${
                  index % 2 === 0 ? '' : ''
                }`}>
                  <i className={`${item.icon} text-white text-3xl`}></i>
                </div>

                {/* Mobile Icon */}
                <div className="lg:hidden flex items-center space-x-4 mb-4">
                  <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-white text-2xl`}></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl shadow-lg text-center">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-fill text-white text-3xl"></i>
            </div>
            <div className="text-3xl font-bold text-teal-600 mb-2">7-14 Days</div>
            <div className="text-gray-700 font-semibold">Average Closing Time</div>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl shadow-lg text-center">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-calendar-check-fill text-white text-3xl"></i>
            </div>
            <div className="text-3xl font-bold text-teal-600 mb-2">Flexible</div>
            <div className="text-gray-700 font-semibold">Choose Your Closing Date</div>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-white p-8 rounded-xl shadow-lg text-center">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-fill text-white text-3xl"></i>
            </div>
            <div className="text-3xl font-bold text-teal-600 mb-2">100%</div>
            <div className="text-gray-700 font-semibold">Title Company Protected</div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-xl text-gray-600 mb-8">
            Ready to start the process? Get your cash offer today.
          </p>
          <a 
            href="tel:+1-915-206-5814"
            className="inline-flex items-center bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-bold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill mr-2"></i>
            Call (915) 206-5814 Now
          </a>
        </div>
      </div>
    </section>
  );
}